var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from 'react';
import Icon from '@mdi/react';
import * as svgIcons from '@mdi/js';
function iconToPath(icon) {
    return "mdi" + icon
        .split('-')
        .map(function (path) { return path.charAt(0).toUpperCase() + path.slice(1); })
        .join('');
}
export var MaterialIcon = function (_a) {
    var type = _a.type, _b = _a.size, size = _b === void 0 ? '1em' : _b, _c = _a.color, color = _c === void 0 ? 'currentColor' : _c, onClick = _a.onClick, props = __rest(_a, ["type", "size", "color", "onClick"]);
    var _d = useState(iconToPath(type)), path = _d[0], setPath = _d[1];
    useEffect(function () {
        setPath(iconToPath(type));
    }, [type]);
    return (React.createElement("i", { className: "anticon", onClick: onClick },
        React.createElement(Icon, __assign({ size: size, color: color }, props, { path: svgIcons[path] }))));
};
//# sourceMappingURL=Component.js.map